import * as React from 'react';
import {runTokenIntents} from '../token';
import {hasOwnProperty} from '../util';
import {Priority} from './constants';
import {debug} from './inspection';
import {runElementTransforms} from './element';
import {addIntentsToRevision} from './ViewRevision';
import type {View} from './types';
import {runLazyStyleIntents} from '../style/StyleIntent';
import type {EngineConfig} from '../providers/EngineConfigProvider';

// React 19 renders boolean `inert`; React 18 only renders string values.
const rendersBooleanInert = parseInt(React.version, 10) >= 19;

export function normalizeInertProp(
  props: {inert?: unknown},
  booleanInert = rendersBooleanInert,
): void {
  if (!hasOwnProperty(props, 'inert')) {
    return;
  }

  const inert = props.inert === true || props.inert === '';
  if (booleanInert) {
    props.inert = inert;
  } else if (inert) {
    props.inert = '';
  } else {
    delete props.inert;
  }
}

export function runDomIntents<
  Props,
  Options extends View.ConfigOptions = never,
>(
  revision: View.ViewRevision<Props>,
  options: Options,
  config?: EngineConfig,
): void {
  // Record generated styles separately from the token assignments that fed them.
  const tokenIntents = runTokenIntents(revision, config);
  addIntentsToRevision(
    revision,
    tokenIntents,
    Priority.Normal,
    config?.themePolicy,
    revision.inspection && tokenIntents?.length
      ? debug.createSource(revision, 'tokens')
      : undefined,
  );

  runElementTransforms(revision);
  runLazyStyleIntents(revision, options, config);
  normalizeInertProp(revision.props as {inert?: unknown});

  if (revision.inspection) {
    debug.attachElementRef(revision);
  }
}
